import { PMethodModule } from './modules/cashier-sdk-modules';
import CreditCard from './modules/web/CreditCard';
import Offline from './modules/web/Offline';
import InPerson from './modules/web/InPerson';
import Wallets from './modules/web/Wallets';

type Methods = {
  [methodId: string]: PMethodModule;
};

class MethodFactory {
  private methods: Methods = {};

  private methodDefs = (methodId: string) => {
    const refs = {
      creditCard: (props) =>
        new CreditCard({
          paymentModule: props.paymentModule,
          methodId,
          query: props.query,
          orderId: props.query.orderId || props.snapshotId,
          visitorId: props.visitorId,
          onError: props.onError,
          onMessage: props.onMessage,
          onPaymentStart: props.onPaymentStart,
          onPaymentComplete: props.onPaymentComplete,
          host: props.host,
          getCardFormApi: props.getCardFormApi,
          sdkInitConfig: props.sdkInitConfig,
        }),
      offline: (props) =>
        new Offline({
          paymentModule: props.paymentModule,
          methodId,
          orderId: props.query.orderId || props.snapshotId,
          onError: props.onError,
          onMessage: props.onMessage,
          onPaymentStart: props.onPaymentStart,
          onPaymentComplete: props.onPaymentComplete,
          host: props.host,
          visitorId: props.visitorId,
          locale: props.query.locale,
        }),
      inPerson: (props) =>
        new InPerson({
          methodId,
          paymentModule: props.paymentModule,
          orderId: props.query.orderId || props.snapshotId,
          onMessage: props.onMessage,
          host: props.host,
          visitorId: props.visitorId,
          locale: props.query.locale,
        }),
      wallet: (props) =>
        new Wallets({
          paymentModule: props.paymentModule,
          methodId,
          orderId: props.query.orderId || props.snapshotId,
          onError: props.onError,
          onMessage: props.onMessage,
          onPaymentStart: props.onPaymentStart,
          onPaymentComplete: props.onPaymentComplete,
          host: props.host,
          visitorId: props.visitorId,
          locale: props.query.locale,
        }),
    };
    return refs[methodId] || refs.wallet;
  };

  public addMethod = (methodId: string, props: any) => {
    const method = this.methodDefs(methodId);
    const methodInstance = method(props);
    this.methods[methodId] = methodInstance;
    return methodInstance;
  };

  public hasMethod = (methodId: string): boolean =>
    this.methods.hasOwnProperty(methodId);

  public getMethod = (methodId: string): PMethodModule =>
    this.methods[methodId];

  public getMethods = () =>
    Object.keys(this.methods).map((key) => this.methods[key]);

  public removeById = (methodId: string) => {
    if (this.getMethod(methodId)) {
      // tslint:disable-next-line:no-dynamic-delete
      delete this.methods[methodId];
    }
  };

  public remove = (methodId?: string) => {
    if (methodId) {
      this.removeById(methodId);
    } else {
      Object.keys(this.methods || {}).forEach((key: string) =>
        this.removeById(key)
      );
    }
  };
}

export default MethodFactory;
